import axios from 'axios';

export default () => {
  return axios.create({
    baseURL: 'https://azan-schedule-server.now.sh/'
  });
};
